module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en-us":{"code":"Code","name":"Name","type_code":"Type code","type_name":"Type name","field_is_required":"This field is required","brand_code_length":"brand code length is 4 characters"}}')
  delete Component.options._Ctor
}
